import { FormGroup } from '@ksyos/design-system';
import type { ValidationErrors } from '../../../../../utils/validation';
import { PractitionerRoleInRequest } from '../../../../../../common/enums/practitionerRoleInRequest';
import { InputText } from '../../../../userDataManagement/InputText';
import { ServiceOrganizationProvider } from '../../utils/v1/ServiceOrganizationProvider';

export interface IOrthCV1RequestAddEditInnerProps {
    errors: ValidationErrors;
    question: IOrthCRequestAddEditField;
    selectedDiagnosticReportProvider: ISelectedDiagnosticReportProvider;
    serviceId: string;
    toelichting: IOrthCRequestAddEditField;
}

interface IOrthCRequestAddEditField {
    error?: string;
    handleChange: (value: string | null) => Promise<void>;
    validateOne: () => void;
    value: string | null;
}

interface ISelectedDiagnosticReportProvider {
    handleChange: (
        selectedDiagnosticReportProviderOrganizationId: string | null,
        selectedDiagnosticReportProviderPractitionerId: string | null
    ) => Promise<void>;
    selectedDiagnosticReportProviderOrganizationId: string | null;
    selectedDiagnosticReportProviderPractitionerId: string | null;
    validateOne: () => void;
}

export function OrthCV1RequestAddEditInner(props: IOrthCV1RequestAddEditInnerProps) {
    // TODO CS-11357 Show evaluation just like in TOO ?

    return (
        <>
            <ServiceOrganizationProvider
                errors={props.errors}
                initialOrganizationId={
                    props.selectedDiagnosticReportProvider.selectedDiagnosticReportProviderOrganizationId
                }
                initialPractitionerId={
                    props.selectedDiagnosticReportProvider.selectedDiagnosticReportProviderPractitionerId
                }
                onChange={async (organizationId, practitionerId) =>
                    props.selectedDiagnosticReportProvider.handleChange(organizationId, practitionerId)
                }
                onDoValidate={props.selectedDiagnosticReportProvider.validateOne}
                roleOfPractitionersInList={PractitionerRoleInRequest.specialist}
                searchInNetwork={true}
                serviceProviderServiceId={props.serviceId}
            />

            <FormGroup
                hasErrors={!!props.question.error}
                isRequired
                label="Vraag"
            >
                <InputText
                    error={props.question.error}
                    nullable={true}
                    onChange={async (value) => await props.question.handleChange(value)}
                    onDoValidate={props.question.validateOne}
                    placeholder="Vraag..."
                    value={props.question.value}
                />
            </FormGroup>

            <FormGroup
                hasErrors={!!props.toelichting.error}
                label="Toelichting"
            >
                <InputText
                    error={props.toelichting.error}
                    nullable={true}
                    onChange={async (value) => await props.toelichting.handleChange(value)}
                    onDoValidate={props.toelichting.validateOne}
                    placeholder="Toelichting..."
                    value={props.toelichting.value}
                />
            </FormGroup>
        </>
    );
}
